var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Profile",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_736",
    cx: 34.7364,
    cy: 21.8341,
    rx: 14.3341,
    ry: 14.3341,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33945",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 56.1042C11.9962 55.0965 12.2216 54.1012 12.6591 53.1934C14.0321 50.4474 17.9039 48.992 21.1168 48.333C23.4338 47.8385 25.7829 47.5082 28.1465 47.3444C32.5225 46.9601 36.9238 46.9601 41.2998 47.3444C43.6632 47.5101 46.0122 47.8404 48.3296 48.333C51.5424 48.992 55.4142 50.3101 56.7872 53.1934C57.6671 55.0438 57.6671 57.192 56.7872 59.0424C55.4142 61.9257 51.5424 63.2438 48.3296 63.8753C46.0152 64.3903 43.6653 64.7299 41.2998 64.8914C37.7381 65.1933 34.1598 65.2483 30.5904 65.0561C29.7666 65.0561 28.9703 65.0561 28.1465 64.8914C25.7899 64.7319 23.449 64.3922 21.1442 63.8753C17.9039 63.2438 14.0595 61.9257 12.6591 59.0424C12.2238 58.1241 11.9987 57.1204 12 56.1042Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.1d7360b5c7590d86e2d0f07dc8a0694d.svg";
export { ForwardRef as ReactComponent };